import { useNavigate } from "react-router-dom";
import { Lock, Sparkles } from "lucide-react";

export const UpgradeCTA = ({ title = "Unlock advanced analytics", body = "Real-time stream progression, unique listeners, retention, demographics, cities and traffic sources.", testId = "upgrade-cta" }) => {
  const nav = useNavigate();
  return (
    <div data-testid={testId} className="relative overflow-hidden surface p-8 sm:p-10">
      <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full blur-3xl opacity-40" style={{ background: "var(--hub)" }} />
      <div className="relative">
        <div className="w-11 h-11 rounded-full bg-white/10 flex items-center justify-center mb-5"><Lock size={18} /></div>
        <h3 className="font-display text-2xl sm:text-3xl font-bold">{title}</h3>
        <p className="text-zinc-400 mt-2 max-w-lg">{body}</p>
        <button data-testid={`${testId}-button`} onClick={() => nav("/pricing")} className="mt-6 inline-flex items-center gap-2 px-6 h-11 rounded-full bg-[var(--hub)] text-white font-semibold hover:brightness-110 transition-[filter]">
          <Sparkles size={16} /> Upgrade to Rising Star
        </button>
      </div>
    </div>
  );
};
